import { render, staticRenderFns } from "./shake-image.vue?vue&type=template&id=43c71688&scoped=true"
import script from "./shake-image.vue?vue&type=script&lang=ts"
export * from "./shake-image.vue?vue&type=script&lang=ts"
import style0 from "./shake-image.vue?vue&type=style&index=0&id=43c71688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c71688",
  null
  
)

export default component.exports